import { PinDropSharp } from '@material-ui/icons';
import React from 'react';
import Oola_lifestyle_framework_image from '../../../../Assets/img/Dashboard/Oola_lifestyle_framework_image.jpeg';
import './Programs.css';

const Programs = ({ goEnroll }) => {
    return (
        <div className="HomePagePrograms__Container">
            <h1>
                Programs <hr />
            </h1>
            <div className="HomePagePrograms__Description">
                <p className="paragraph-2">
                    A revolutionary personal development system combining a
                    proven lifestyle framework, fully-customized online courses,
                    and a global network of Certified Coaches to help you along
                    your journey.
                </p>
            </div>
        </div>
    );
};

export default Programs;
